import {
  CloudUpload,
  Gauge,
  ListChecks,
  Loader2,
  Send,
  type LucideIcon,
} from 'lucide-react';

/** Map between the wizard step ids and their canonical lucide icon. */
const ICONS: Record<string, LucideIcon> = {
  upload: CloudUpload,
  analyzing: Loader2,
  review: ListChecks,
  maturity: Gauge,
  publish: Send,
};

export interface StepperIconProps {
  stepKey: string;
  /** When the step is the active one, the analyzing icon spins. */
  active?: boolean;
  className?: string;
}

/**
 * Tiny wrapper that resolves a step id to its lucide icon. Kept separate from
 * `DiscoveryWizard` so it can be reused in breadcrumbs/empty-states without
 * dragging the wizard's layout responsibilities along.
 */
export function StepperIcon({ stepKey, active = false, className }: StepperIconProps): JSX.Element | null {
  const Icon = ICONS[stepKey];
  if (Icon === undefined) {
    return null;
  }
  const spin = active && stepKey === 'analyzing';
  return <Icon className={className} aria-hidden strokeWidth={2} {...(spin ? { 'data-spin': '' } : {})} />;
}
